import mapFunction from './mapResources';

export default mapFunction('building_equipment', {
    isFetching: false,
    items: [] 
});
